(() => {
  if (window.doreEditableBlocksReady) return;
  window.doreEditableBlocksReady = true;
  document.addEventListener('product:rerender', event => {
    const fragment = event.detail?.htmlFragment;
    if (!fragment?.querySelectorAll) return;
    fragment.querySelectorAll('[data-dore-static]').forEach(block => block.removeAttribute('data-block-id'));
  }, true);
  const tick = () => {
    document.querySelectorAll('[data-dore-dispatch]').forEach(block => {
      const output = block.querySelector('[data-dore-countdown]');
      if (!output) return;
      const parts = new Intl.DateTimeFormat('en-AU', {timeZone: block.dataset.timezone || 'Australia/Sydney', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'}).formatToParts(new Date());
      const time = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const cutoff = Number(block.dataset.cutoff || 24) * 60;
      let left = cutoff - (Number(time.hour) * 60 + Number(time.minute));
      if (left <= 0) left += 1440;
      const hours = Math.floor(left / 60);
      const value = hours + 'h ' + String(left % 60).padStart(2, '0') + 'm';
      if (output.textContent !== value) output.textContent = value;
    });
  };
  document.addEventListener('shopify:section:load', tick);
  document.addEventListener('visibilitychange', tick);
  tick();
  setInterval(tick, 30000);
})();
